import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuItem } from '../../services/menuService';

// Define slice state interface
interface MenuState {
  menuItems: MenuItem[];
  loading: boolean;
  error: string | null;
}

// Define initial state
const initialState: MenuState = {
  menuItems: [],
  loading: false,
  error: null,
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    // Fetch menu actions
    fetchMenuRequest: (state, action: PayloadAction<{ restaurantId: string; type?: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuSuccess: (state, action: PayloadAction<MenuItem[]>) => {
      state.loading = false;
      state.menuItems = action.payload;
      state.error = null;
    },
    fetchMenuFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Clear menu
    clearMenu: (state) => {
      state.menuItems = [];
      state.loading = false;
      state.error = null;
    },
  },
});

// Export actions
export const {
  fetchMenuRequest,
  fetchMenuSuccess,
  fetchMenuFailure,
  clearMenu,
} = menuSlice.actions;

export default menuSlice.reducer;
